
const contactUs = {
  'contactUs.title': 'Contáctanos',
  'contactUs.subtitle': 'Estamos aquí para ayudarte',
  'contactUs.whatsapp.title': 'Contáctanos por WhatsApp',
  'contactUs.email.title': 'Contáctanos por correo electrónico',
  'contactUs.whatsapp.urgent': 'Para consultas urgentes, contáctanos directamente por WhatsApp. Nuestro equipo te responderá lo antes posible.',
  'contactUs.languages.english': 'English',
  'contactUs.languages.italian': 'Italiano',
  'contactUs.languages.spanish': 'Español',
  'contactUs.languages.german': 'Deutsch',
  'contactUs.languages.croatian': 'Hrvatski',
  'contactUs.languages.turkish': 'Türkçe',
  'contactUs.languages.french': 'Français',
  'contactUs.languages.arabic': 'العربية',
};

export default contactUs;
